module.exports = {"common":{"breadcrumb":{"home":"HOME","Directory":"Channel","server":"Channel Details","create_azure_ad_btn":"Add Channel Credentials"}},"create_azure_ad":{"title":{"header":"Channel credentials","desc":""},"btn":{"save":"Add","close":"Close","validate":"Validate"},"inputs":{"clientId":{"label":"Client Id","placeholder":"Enter Client Id"},"objectId":{"label":"Object Id","placeholder":"Enter Object Id"},"secretKey":{"label":"Secret Value","placeholder":"Enter Secret Value"},"status":{"label":"Status"}}},"update_azure_btn":{"update":"Update"}}


//////////////////
// WEBPACK FOOTER
// ./lang/en/appCredentials.json
// module id = 1083
// module chunks = 32